export default {
  rating: {
    type: Number,
    default: -1,
  },
  isSmall: {
    type: Boolean,
    default: false,
  },
  isInteractive: {
    type: Boolean,
    default: false,
  },
  hasAlert: {
    type: Boolean,
    default: false,
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
}
